// BusinessUnits.js
import React from 'react';
import { motion } from 'framer-motion';
import industrialImg from '../assets/industry.jpg';
import energyImg from '../assets/energy.jpg';
import '../styles/colors.css';
import CardImg from './CardImg';

const BusinessUnits = () => {
  // Datos de las unidades de negocio
  const unitsData = [
    
    { title: 'Ingeniería Electromecánica', description: 'Desarrollamos ingeniería de detalle, consultoría y asesoramiento técnico-comercial para soluciones personalizadas asegurando precisión, eficiencia y cumplimiento de los más altos estándares técnicos.', img: energyImg, link: '#servicesElect' },
    { title: 'Industria 4.0', description: 'Ofrecemos soluciones de automatización a medida para la  transformación digital de procesos industriales mediante tecnologías avanzadas que integran IoT, robótica y sistemas inteligentes para optimizar la productividad.', img: industrialImg, link: '#servicesIndustria' },
  ];

  return (
    // Sección animada con framer-motion
    <motion.section
      id="business"
      className="py-10" // Padding vertical de 10
        style={{
          backgroundColor:'var(--background-color-typeB)', // Color de fondo
          //color:'var(--text-color-typeA)',
         }} // Altura mínima del 80% del viewport
      initial={{ opacity: 0 }} // Opacidad inicial
      animate={{ opacity: 1 }} // Opacidad final
      transition={{ duration: 1 }} // Duración de la transición
      
    >
      <div className="container mx-auto px-[5%] text-center "> 
        <h3 className="text-3xl mb-12"
          style={{
            color:'var(--primary-text-color)',
            fontWeight:'bold',
           }}> 
          ÁREAS DE ACCIÓN
        </h3> 
        {/* Grid de unidades de negocios */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8"> 
          {unitsData.map((unit, index) => (
            <CardImg 
              key={index}
              title={unit.title}
              description={unit.description}
              img={unit.img} 
              link={unit.link}> 
            </CardImg>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default BusinessUnits;


